import { render, staticRenderFns } from "./inputTextmap.pug?vue&type=template&id=8d03bb36&lang=pug&"
import script from "./inputTextmap.js?vue&type=script&lang=js&"
export * from "./inputTextmap.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d03bb36')) {
      api.createRecord('8d03bb36', component.options)
    } else {
      api.reload('8d03bb36', component.options)
    }
    module.hot.accept("./inputTextmap.pug?vue&type=template&id=8d03bb36&lang=pug&", function () {
      api.rerender('8d03bb36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/textmap/index.vue"
export default component.exports